import React, { useEffect, useCallback } from 'react'

import classnames from 'classnames'
import dayjs from 'dayjs'
import Link from 'next/link'
import { Button, message, Modal } from 'antd'
import PageHeader from '@/components/PageHeader'
import Copyright from '@/components/Copyright'

import http from '@/utils/request'
import useReducers from '@/store/guide'

import styles from './GuideLayout.module.scss'

export default React.memo(function GuideLayout({ className, title, children, hideNav, bordered = true }) {
  const [state, actions] = useReducers()

  useEffect(() => {
    actions.getPosts(2).then(res => {
      actions.updateSelectedPost(res.payload[0].id)
    })
  }, [])

  const handleClick = useCallback((id) => {
    actions.updateSelectedPost(id)
  }, [])

  return (
    <>
      <PageHeader title={title} />
      <div className={classnames(styles.container, className)}>
        <div className={styles.navs}>
          {
            state.posts?.map(post => {
              return (
                <Button key={post.id} onClick={() => handleClick(post.id)} type="link" className={styles.nav}>{post.post_title}</Button>
              )
            })
          }
        </div>
        <div className={classnames(styles.main, { [styles.bordered]: bordered })}>
          { children }
        </div>
      </div>

      <Copyright/>
    </>
  )
})
